import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SafeUrlPipe } from './safe-url.pipe';
import { UriService } from './uri.service';

@NgModule({
  imports: [CommonModule],
  declarations: [SafeUrlPipe],
  providers: [UriService],
  exports: [SafeUrlPipe],
})
export class UriModule {}
